import { InjectionToken } from "@angular/core";
import { StorePaymentAPI, StorePurchaseApi, StoreTaxExemptionAPI, StoreValidateAddressAPI } from "../store-api";

export const storePurchaseAPIInjector = new InjectionToken<StorePurchaseApi>('StorePurchaseApi');
export const storePaymentAPIInjector = new InjectionToken<StorePaymentAPI>('StorePaymentAPI');
export const storeTaxExemptionAPIInjector = new InjectionToken<StoreTaxExemptionAPI>('StoreTaxExemptionAPI');
export const storeValidateAddressAPIInjector = new InjectionToken<StoreValidateAddressAPI>('StoreValidateAddressAPI');